export const PROJECT_WORKSPACE_NODE_WIDTH = 220;
export const PROJECT_WORKSPACE_NODE_HEIGHT = 176;
